import type { ReactNode } from 'react';

interface CartaoProps {
  variante?: 'solido' | 'vidro';
  className?: string;
  children: ReactNode;
}

export default function Cartao({ variante = 'solido', className = '', children }: CartaoProps) {
  const base =
    variante === 'vidro'
      ? 'bg-white/85 backdrop-blur-md shadow-xl'
      : 'bg-white border border-secondary-100 shadow-sm';
  return <div className={`rounded-3xl ${base} ${className}`}>{children}</div>;
}